<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" fullscreen persistent>
      <v-card class="risk-assessment" height="100%">
        <v-form ref="form" v-model="valid" class="scroll-form" lazy-validation>
          <v-card-title
            class="headline indigo darken-4 white--text fixed-header"
            primary-title
          >
            {{
              $vuetify
                .t('$vuetify.powra.pointOfWorkRiskAssessment')
                .toUpperCase()
            }}
          </v-card-title>
          <v-layout row wrap>
            <PowraTitle
              :avatar="'G'"
              :title="$vuetify.t('$vuetify.powra.sectionGHeadline')"
            />
            <v-flex
              xs12
              px-3
              py-3
              :class="
                index % 2 == 0
                  ? 'subheading font-weight-bold blue-grey lighten-5'
                  : 'subheading font-weight-bold'
              "
              v-for="(hazard, index) in hazards"
              v-if="hazard"
              :key="index"
            >
              {{ hazard.name }}<br />
              <v-select
                :items="newControlMeasures"
                :label="$vuetify.t('$vuetify.powra.controlMeasure')"
                v-model="hazardControls[hazard.code].controls"
                outline
                class="mt-3"
                :rules="controlMeasuresRules"
                required
                item-text="name"
                item-value="code"
                multiple
                return-object
              ></v-select>
              <v-text-field
                :label="$vuetify.t('$vuetify.powra.comments')"
                v-model="hazardControls[hazard.code].comments"
                outline
              ></v-text-field>
            </v-flex>
          </v-layout>

          <div class="footer text-xs-center mb-3">
            <v-divider></v-divider>
            <v-card-text>
              <v-btn @click="back()">
                {{ $vuetify.t('$vuetify.calls.back') }}
              </v-btn>

              <v-btn color="success" :disabled="!valid" @click="confirm()">
                {{ $vuetify.t('$vuetify.calls.proceedToTheNextSection') }}
              </v-btn>
              <abort-visit v-on:aborted="visitAborted(...arguments)" />
            </v-card-text>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AbortVisit from '@/components/AbortVisit.vue'
import PowraTitle from '@/components/powra/PowraTitle.vue'
import { mapGetters, mapState } from 'vuex'
import powraData from '../../data/forms/powra.json'

export default {
  props: ['show', 'controls', 'hazards'],
  components: {
    AbortVisit,
    PowraTitle
  },
  data() {
    return {
      valid: true,
      controlMeasuresRules: [
        v =>
          !!v ||
          this.$vuetify.t('$vuetify.powra.controlMeasure') + ' is required'
      ],
      dialog: false,
      powraData,
      newControlMeasures: [],
      componentLoaded: false
    }
  },
  computed: {
    ...mapGetters({
      hasPowra: 'calls/hasPowra',
      currentRiskAssessment: 'calls/currentRiskAssessment',
      getHazards: 'calls/getHazards',
      getControls: 'calls/getControls',
      getHazardControls: 'calls/getHazardControls'
    }),

    hazardControls() {
      var hazardControls = []
      console.log('HAZARDS...', this.hazards, this.getHazards)
      _.each(this.getHazards, hazard => {
        console.log(hazard)
        if (hazard) {
          hazardControls[hazard.code] = {
            hazard: hazard,
            controls: this.getHazardControls[hazard.code]
              ? this.getHazardControls[hazard.code].controls
              : null,
            comments: this.getHazardControls[hazard.code]
              ? this.getHazardControls[hazard.code].comments
              : null
          }
        }
      })
      return hazardControls
    }
  },
  created() {
    this.$watch(state => state, this.handleStateUpdate)
  },
  methods: {
    confirm() {
      if (this.$refs.form.validate()) {
        this.dialog = false
        this.$emit('confirmed', this.hazardControls)
      }
    },
    visitAborted() {
      this.dialog = false
      this.$emit('aborted')
    },
    back() {
      this.dialog = false
      this.$emit('back')
    },
    populateActivePowraValues() {},
    updateSelectInput(controls) {
      this.newControlMeasures = []
      _.mapKeys(controls, val => {
        if (!_.isNull(val)) {
          this.newControlMeasures.push(val)
        }
      })
    }
  },
  watch: {
    show: function(newVal, oldVal) {
      this.dialog = newVal
    },

    controls: {
      handler: function(newVal, oldVal) {
        this.updateSelectInput(newVal)
      },
      deep: true
    },

    hasPowra: function() {
      if (this.hasPowra) {
        this.populateActivePowraValues()
      }
    }
  }
}
</script>

<style scoped>
.footer {
  position: -webkit-sticky;
  position: sticky;
  background-color: #ffffff;
  bottom: 0;
  width: 100%;
  height: 100px;
}
.fixed-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 300;
}
.scroll-form {
  height: 100%;
  position: relative;
  overflow-y: scroll;
}
</style>
